import { Layout, Button, Input, message, Tabs, Row, Col, Breadcrumb, Skeleton, Upload, Select, Empty,} from 'antd'
import OAMSider from '../oam-sider'
import React, { useEffect, useState } from 'react'
import { sendHttpPostRequest } from '../../../api/http-request'
import Cookies from 'js-cookie'
//import css from '@/pages/case/CaseDetail/case-detail.module.less'
import { useHistory, useLocation } from 'react-router'
import GlobalCss from '@/global.module.less'
import * as constants from '@/constants/constants'
import defaultCaseCover from '@/static/image/case/default_case_cover.png'
import TextArea from 'antd/lib/input/TextArea'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import rehypeRaw from 'rehype-raw'
import 'katex/dist/katex.min.css'
import gfm from 'remark-gfm'
import rehypeHighlight from 'rehype-highlight'

const { Option } = Select

export interface Props {}

/** OAM 镜像预览页 */
export const OAMImagePreview: React.FC<Props> = (props:any) => {
  //const location = useLocation()
  //const imageId = location?.search?.split('image_id=')[1]
  //const fromOAM = location.pathname?.includes('oam') ? 1 : 0
  const imageId = props.location.search.split('=')[1]
  //const history = useHistory()
  const [userLogin, setUserLogin] = useState(false) // 用户登录状态

  const [imageName, setImageName] = useState('')
  const [imageDescription, setImageDescription] = useState('')
  const [imageServeUrl, setImageServeUrl] = useState('')


  const [editState, setEditState] = useState(false)


  const onImageNameChange = (e) => {
    setImageName(e.target.value)
  }

  const onImageDescriptionChange = (e) => {
    setImageDescription(e.target.value)
  }

  const onImageServeUrlChange = (e) => {
    setImageServeUrl(e.target.value)
  }

  /**
   * 查询镜像信息
   */
  const queryImage = () => {
    let params = {
      sessionid: Cookies.get('sessionid'),
      env_id: imageId,
    }
    sendHttpPostRequest(
      'course/api/oam_query_project_environment_by_id',
      params,
      queryImageCallback
    )
  }

  /**
   * 查询镜像回调
   * @param response
   */
  const queryImageCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      setUserLogin(false)
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == 0) {
      setUserLogin(true)
      setImageName(response?.data.name)
      setImageDescription(response?.data.description)
      setImageServeUrl(response?.data.server_url)

    } else {
      message.error(response.message)
    }
  }

  // 保存镜像信息回调
  const saveImageInfoCallback = (response: any) => {
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.is_ok) {
      queryImage()
    } else {
      message.error(response.message)
    }
  }


  const onSave = () => {
    setEditState(false)
    sendHttpPostRequest(
      'course/api/oam_update_project_environment',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        environment_id: imageId,
        description: imageDescription,
        name: imageName,
        server_url: imageServeUrl
      },
      saveImageInfoCallback
    )
  }


  const add_link_target = ()=>{
    setTimeout(function(){
      const a_links = document.getElementsByTagName("a") //链接改为新弹出窗口效果
      for(let i=0; i < a_links.length;  i++){
          try{
            let href_ = a_links[i].getAttribute("href") as any
            if ( href_.indexOf('http') >= 0){
              a_links[i].setAttribute('target', '_blank');
            }
            
          }catch(error1){
            console.log(error1)
          }
        }
    }, 2000); //单位是毫秒

  }

  useEffect(() => {
    window.onload = function(){
      try{
        add_link_target()
      }catch(error){
        console.log(error)
      }
    } 
    queryImage()
  }, [])

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <OAMSider keys={['21']} openKeys={['sub-project']}/>
      <div style={{ width: '100%', minWidth:1000, backgroundColor:'rgb(249, 249,249)'}}>
        <Breadcrumb style={{ marginLeft: 'auto',  marginRight: 'auto',  marginTop: 20, maxWidth: 1100}}>
          <Breadcrumb.Item></Breadcrumb.Item>
          <Breadcrumb.Item>镜像预览</Breadcrumb.Item>
        </Breadcrumb>
        <div style={{minHeight:800, padding:10,marginLeft:'auto', marginRight:'auto', marginBottom:30,maxWidth:1100, borderRadius:5, backgroundColor:'#fff'}}>
        
         <div  style={{ margin:"10px 0px", float: 'right' }}>
                {!editState ? (
                  <div 
                  //className={css.btnGroup}
                  >
                    <Button
                      className={GlobalCss.radiusBtn + ' ' + GlobalCss.defBtn}
                      onClick={() => setEditState(true)}
                    >
                      编辑
                    </Button>
                  </div>
                ) : editState ? (
                  <Button
                    className={GlobalCss.radiusBtn}
                    type="primary"
                    onClick={onSave}
                  >
                    保存
                  </Button>
                ) : (
                  ''
                )}
           </div>

        
          <Row
            align={'middle'}
            justify={'start'}
            style={{  width: '100%', minHeight:32, marginBottom:10}}
            wrap={false}
          >
            <Col  span={4}>
              镜像名称：
            </Col>
            <Col  span={20}>
            {editState ? (
              <Input
                maxLength={40}
                onChange={onImageNameChange}
                value={imageName}
                placeholder="请输入镜像名称"
              />):<div style={{textAlign:'left'}}>{imageName}</div>
            }
            </Col>

          </Row>
                


          <Row
            align={'middle'}
            justify={'start'}
            style={{ width: '100%',minHeight:32 , marginBottom:10}}
            wrap={false}
          >
            <Col span={4}>
              服务地址：
            </Col>

            <Col span={20}>

            {editState ? (
                <Input
                  maxLength={100}
                  onChange={onImageServeUrlChange}
                  value={imageServeUrl}
                  placeholder="请输入镜像服务地址"
                />
              ):<div style={{textAlign:'left'}} >{imageServeUrl}</div>
            }
            
            </Col>

          </Row>


           
          <Row
            align={'top'}
            justify={'start'}
            style={{  width: '100%',minHeight:32 , marginBottom:10}}
            wrap={false}
          >
            <Col  span={4}>
            镜像描述：
            </Col>

            <Col  span={20}>

            {editState ? (
              <TextArea
                    style={{ borderRadius: 3 }}
                    value={imageDescription}
                    defaultValue={imageDescription}
                    onChange={onImageDescriptionChange}
                    placeholder="请输入镜像描述"
                    autoSize = {{ minRows: 10, maxRows: 30 }}
                  />
              ):<div 
              //className={css.markdownContain}
              >
                  <ReactMarkdown
                  remarkPlugins={[gfm, remarkMath]}
                  rehypePlugins={[
                    rehypeHighlight,
                    rehypeKatex,
                    rehypeRaw,
                  ]}
                  >
                    {imageDescription}
                  </ReactMarkdown>
            </div>
            }
            
            </Col>

          </Row>             
        </div>
      </div>
    </Layout>
  )
}

export default OAMImagePreview
